import { PHONE_MSG } from "@genbaryoku/contract";
import type { ReactNode } from "react";
import { PhIcon } from "./icons.jsx";

/**
 * 撮る・選ぶ（<label> の中の見えない input。display:none の input を click() で開かない＝Safari が開かない。docs/10 §5.10）
 */
export function PhotoInput({ capture, multiple, onFiles, className, children, testId, label }: { capture?: boolean; multiple?: boolean; onFiles: (f: File[]) => void; className: string; children: ReactNode; testId?: string; label?: string }) {
  return (
    <label className={className} data-testid={testId} aria-label={label}>
      <input
        type="file"
        accept="image/*"
        className="vh"
        {...(capture ? { capture: "environment" as const } : {})}
        multiple={!!multiple}
        onChange={(e) => {
          const files = [...(e.target.files ?? [])];
          e.target.value = "";
          if (files.length) onFiles(files);
        }}
        data-testid={testId ? `${testId}-input` : undefined}
      />
      {children}
    </label>
  );
}

/** スマホの見積の下の帯の「撮影」（差し込み口 phone.shoot。モジュール field の会社だけ。#142 段2） */
export function PhoneShootButton({ onFiles }: { onFiles: (files: File[]) => void }) {
  return (
    <PhotoInput capture className="btn primary ph-main" onFiles={onFiles} testId="phone-shoot">
      <PhIcon k="camera" />
      {PHONE_MSG.shoot}
    </PhotoInput>
  );
}
